import { t } from "@lingui/core/macro";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import graphql from "babel-plugin-relay/macro";
import { Image } from "react-native";
import { useFragment } from "react-relay";

import { ClubStackNavigatorParamList } from "@/navigators/ClubNavigator";
import { Button } from "@whoosh/design-system/src/components/controls";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

import { StorePackageSuccess_package$key } from "./__generated__/StorePackageSuccess_package.graphql";

type Props = {
  packageRef?: StorePackageSuccess_package$key | null;
};

export const StorePackageSuccess = ({ packageRef }: Props) => {
  const navigation =
    useNavigation<NavigationProp<ClubStackNavigatorParamList>>();

  const onGoHomePress = () => {
    navigation.navigate("Home", { screen: "MainHome" });
  };

  const pkg = useFragment(StorePackageSuccessFragmentString, packageRef);
  const isMembership = pkg?.__typename === "MembershipPackage";

  return (
    <VStack
      flex={1}
      py={10}
      px={6}
      gap={8}
      alignItems="center"
      justifyContent="center"
    >
      <Box
        bg="surface-primary"
        width={73}
        height={73}
        alignItems="center"
        justifyContent="center"
        shadowColor="icon-primary"
        shadowOpacity={0.2}
        shadowOffset={{ height: 8, width: 0 }}
        shadowRadius={24}
        style={{ borderRadius: 9999 }}
      >
        <Image
          source={require("./star-icon.png")}
          style={{ height: 73, width: 73 }}
          accessible={false}
        />
      </Box>
      <VStack gap={2} alignItems="center" px={3}>
        <Text textAlign="center" variant="mainTitle3">
          {isMembership
            ? t`You're in! Your membership is officially activated!`
            : t`Success! Your Package is confirmed!`}
        </Text>
        <Text width={248} textAlign="center" variant="mainSmallMedium">
          {isMembership
            ? t`You've successfully purchased your membership.`
            : t`You've successfully purchased your package.`}
        </Text>
      </VStack>
      <Box
        height={3}
        width={80}
        backgroundColor="surface-dividers"
        borderRadius="2"
      />
      <HStack gap={4}>
        <Button
          accessibilityLabel={t`Get Started`}
          size="small"
          width={240}
          onPress={onGoHomePress}
        >{t`Get Started`}</Button>
      </HStack>
    </VStack>
  );
};

const StorePackageSuccessFragmentString = graphql`
  fragment StorePackageSuccess_package on Package {
    __typename
  }
`;
